'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _components = require('../../components');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _dates = require('../../utils/dates');

var _reactIntl = require('react-intl');

var _urls = require('../../utils/urls');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _safelyRender = require('../../utils/safelyRender');

var _safelyRender2 = _interopRequireDefault(_safelyRender);

var _HorizontalCatalogCard = require('./HorizontalCatalogCard.scss');

var _HorizontalCatalogCard2 = _interopRequireDefault(_HorizontalCatalogCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorizontalCatalogCard = (_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(HorizontalCatalogCard, _Component);

    function HorizontalCatalogCard() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, HorizontalCatalogCard);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = HorizontalCatalogCard.__proto__ || (0, _getPrototypeOf2.default)(HorizontalCatalogCard)).call.apply(_ref, [this].concat(args))), _this), _this.limitDescription = function (description) {
            if (description && description.length > 139) {
                description = description.slice(0, 139).trim() + '\u2026';
            }
            return (0, _safelyRender2.default)(description);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(HorizontalCatalogCard, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['className', 'featured', 'cardViewModel']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                cardViewModel = _props.cardViewModel,
                className = _props.className,
                featured = _props.featured;
            var catalog = cardViewModel.catalog,
                coverLots = cardViewModel.coverLots,
                seller = cardViewModel.seller;

            var _ref2 = catalog || {},
                catalogId = _ref2.catalogId,
                catalogStatus = _ref2.catalogStatus,
                description = _ref2.description,
                isCatalogOnly = _ref2.isCatalogOnly,
                saleStartTs = _ref2.saleStartTs,
                title = _ref2.title;

            var _ref3 = seller || {},
                sellerId = _ref3.sellerId;

            var classes = [].concat((0, _toConsumableArray3.default)(className.split(' ')), [_HorizontalCatalogCard2.default['catalog-card']]).join(' ').trim();

            var coverLotsClasses = featured ? _HorizontalCatalogCard2.default.featured + ' ' + _HorizontalCatalogCard2.default['cover-lots'] : _HorizontalCatalogCard2.default['cover-lots'];
            var startDate = (0, _dates.catalogCardDate)(saleStartTs);
            var catalogUrl = (0, _urls.getCatalogUrl)(catalogId, title);

            return (0, _jsx3.default)('div', {
                className: classes
            }, void 0, (0, _jsx3.default)('div', {
                className: _HorizontalCatalogCard2.default['card-body']
            }, void 0, (0, _jsx3.default)('div', {
                className: _HorizontalCatalogCard2.default.left
            }, void 0, (0, _jsx3.default)(_components.CoverLots, {
                catalogUrl: catalogUrl,
                className: coverLotsClasses,
                coverLots: coverLots,
                featured: featured,
                sellerId: sellerId
            })), (0, _jsx3.default)('div', {
                className: _HorizontalCatalogCard2.default.middle
            }, void 0, (0, _jsx3.default)('div', {
                className: _HorizontalCatalogCard2.default.title
            }, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: catalogUrl,
                primary: true
            }, void 0, title)), (0, _jsx3.default)('div', {
                className: _HorizontalCatalogCard2.default.description
            }, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: catalogUrl,
                primaryWeak: true
            }, void 0, this.limitDescription(description)))), (0, _jsx3.default)('div', {
                className: _HorizontalCatalogCard2.default.right
            }, void 0, (0, _jsx3.default)('div', {
                className: _HorizontalCatalogCard2.default['start-date']
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'starts_at',
                values: { startDate: startDate }
            })), catalogStatus === 'live' && !isCatalogOnly ? (0, _jsx3.default)('div', {
                className: _HorizontalCatalogCard2.default['live-link-container']
            }, void 0, (0, _jsx3.default)(_components.BidConsoleOpener, {
                catalogId: catalogId
            }, void 0, (0, _jsx3.default)('span', {
                className: _HorizontalCatalogCard2.default.live
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'live_auction'
            })))) : !isCatalogOnly && (0, _jsx3.default)(_components.CatalogDate, {
                className: _HorizontalCatalogCard2.default.countdown,
                date: saleStartTs,
                forceCountdown: true
            }), (0, _jsx3.default)(_components.ButtonLink, {
                url: catalogUrl,
                className: _HorizontalCatalogCard2.default.explore
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'explore'
            })), (0, _jsx3.default)(_components.RegisterLinkContainer, {
                className: _HorizontalCatalogCard2.default['register-link'],
                catalogId: catalogId,
                isCatalogOnly: isCatalogOnly
            }))));
        }
    }]);
    return HorizontalCatalogCard;
}(_react.Component), _class.defaultProps = {
    cardViewModel: {},
    className: '',
    featured: false
}, _temp2);
exports.default = HorizontalCatalogCard;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CatalogCard/HorizontalCatalogCard.js
// module id = QJZ2
// module chunks = 46